import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.55556 21L16.4444 21C16.857 21 17.2527 20.8361 17.5444 20.5444C17.8361 20.2527 18 19.857 18 19.4444L18 18L16.4444 18L16.4444 18.48L15.9645 18L14.0356 18L15.48 19.4444L13.5589 19.4444L12.1145 18L10.1763 18L11.63 19.4444L9.70889 19.4444L8.14211 17.8777C8.58368 18.023 9 18 9 18L15 18L19 18C19.5304 18 20.0391 17.7893 20.4142 17.4142C20.7893 17.0392 21 16.5305 21 16L21 6.00002C21 5.46959 20.7893 4.96088 20.4142 4.58581C20.0391 4.21073 19.5304 4.00002 19 4.00002L9 4.00002C8.46957 4.00002 7.96086 4.21073 7.58579 4.5858C7.21071 4.96088 7 5.46959 7 6.00002L7 7L5.55556 7C5.143 7 4.74734 7.16389 4.45561 7.45561C4.16389 7.74733 4 8.143 4 8.55555L4 19.4444C4 19.857 4.16389 20.2527 4.45561 20.5444C4.74734 20.8361 5.143 21 5.55556 21ZM7 8.55555L6.52 8.55555L7 9.03555L7 8.55555ZM7 10.9644L5.55556 9.52L5.55556 11.4411L7 12.8856L7 10.9644ZM7 14.8441L5.55556 13.4089L5.55556 15.2911L7.12234 16.8579C6.97703 16.4163 7 16 7 16L7 14.8441ZM9 7L16.4469 7L16.4444 7L9 7ZM5.55556 17.2589L7.78 19.4444L5.55556 19.4444L5.55556 17.2589ZM19 16L9 16L9 7L9 6.00002L19 6.00002L19 16Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDropShadow = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDropShadow;
